import * as yup from 'yup';
import {
  AccountDTO,
  GrantDTO,
  GranTypeDTO,
} from '../../../../Profile/Accounts/api/useAccountsQuery';

interface VestingListItem {
  VestedShares: number;
  VestingYear: number;
}

export interface Grant extends Omit<GrantDTO, 'Id' | 'VestingList'> {
  Id?: string;
  VestingList: Partial<VestingListItem>[];
}

export interface Account extends Partial<Omit<AccountDTO, 'Id' | 'GrantList'>> {
  Id?: string;
  GrantList: Grant[];
}

export interface FormValues {
  name: string;
  owner: string;
  grantType: GranTypeDTO;
  marketValue: number;
  totalShares: number;
  customAssetBucketIndex: number | null;
  grantYear: number;
  pricePerShare: number;
  expectedReturn: number | null;
  assetClass: number;
  earmarks: { label: string; value: string }[];
  vestingList: Partial<VestingListItem>[];
  orionManagementStyleId: number | null;
}

export const validation = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Please specify a Company Name.'),
  owner: yup
    .string()
    .nullable()
    .required('Please specify an owner for this account.'),
  totalShares: yup
    .number()
    .nullable()
    .test('total-shares-greater-than-zero', 'Total Shares must be greater than 0.', value => {
      if (typeof value !== 'number') {
        return false;
      }

      return value > 0;
    }),
});
